import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from "react-paginate";
import moment from "moment";

function ApprovetimesheetCom() {
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let BASE_URL = process.env.REACT_APP_APP_URL;
	let token = JSON.parse(localStorage.getItem('key'));
	const pagination = useRef();
	const userId = localStorage.getItem('userId');
	const [tab, setTab] = useState(true)
	const [pending, setPending] = useState([])
	const [approval, setApproval] = useState([])
	const [perPage, setPerpage] = useState('');
	const [totalitem, setTotalitem] = useState('');
	const setPage = ({ selected }) => {
		getTimesheetListPending(selected + 1);
	}
	useEffect(() => {
		getTimesheetListPending(1)
		getTimesheetListApprove(1)

	}, [])
	const getTimesheetListPending = async (pagenumber) => {
		const response = await fetch(SERVER_URL + `api/attendance/timesheet-approval-list?action=pending&&page=${pagenumber == 'undefined' ? 1 : pagenumber}`, {
			method: 'get',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': `bearer ${token.value}`
			},
		})
			.then(res => res.json())
			.then(data => { 
				if (data.status == true) {
					setPending(data.data)
					setTotalitem(data.totalCount[0].total);
					setPerpage(data.limit)
				}
			})
	}
	const getTimesheetListApprove = async (pagenumber) => {
		const response = await fetch(SERVER_URL + `api/attendance/timesheet-approval-list?action=approval&&page=${pagenumber == 'undefined' ? 1 : pagenumber}`, {
			method: 'get',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'authorization': `bearer ${token.value}`
			},

		})
			.then(res => res.json())
			.then(data => {
				if (data.status == true) {
					setApproval(data.data)
					// setTotalitem(data.totalCount[0].total);
					// setPerpage(data.limit)
				}
				//console.log(data.totalCount[0].total)
			})
	}
	const handleTab = () => {
		setTab(!tab)
	}

	const handleApproved = (id, user_id, app_date, start_time, end_time, att_id) => {
		// alert(id)
		// alert(user_id)
		// alert(app_date)
		// alert(start_time)
		// alert(end_time)
		// alert(att_id)
		const response = fetch(SERVER_URL + `api/attendance/timesheet-approved`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					RequestID: id,
					RequestUserID: userId,
					action: 1,
					attId: att_id,
					attUserID: user_id,
					startTime: start_time,
					requestType:2,
					endTime: end_time,
					attDate: app_date
				}),
			})
			.then(res => res.json())
			.then(data => { 
				if (data.status == true) {
					getTimesheetListPending()
					getTimesheetListApprove()
				}
			})
		// console.log(response)
	}
	return (
		<div className="container-fluid">
			<div className="dash_ttl">
				Approve Time Sheet
			</div>
			<div className="crumbs">
				<ul id="breadcrumbs" className="breadcrumb">
					<li>
						<Link to="/dashboard">Dashboard </Link>
					</li>/
					<li>
						<Link to="/attendance"> Attendance </Link>
					</li>
					<li className="current">
						<span>/</span> Approve Time Sheet
					</li>
				</ul>
			</div>
			<div className="content_wrp">
				<ul className="nav nav-tabs" role="tablist">
					<li className="nav-item">
						<Link className={`nav-link ${tab == true ? 'active' : ''}`} data-bs-toggle="tab" onClick={handleTab} >Approval Pending</Link>
					</li>
					<li className="nav-item">
						<Link className={`nav-link ${tab == false ? 'active' : ''}`} data-bs-toggle="tab" onClick={handleTab}>Approval History</Link>
					</li>
				</ul>

				<div className="tab-content tab_wrapper">
					<div id="pending" className={`tab-pane ${tab == true ? 'active' : ''}`}>
						<table className="table_style_1">
							<thead>
								<tr>
									<th>Employee Code</th>
									<th>Employee Name</th>
									<th>In Time</th>
									<th>Out Time</th>
									<th>Application Date </th>
									<th style={{ width: "200px !important" }}>Reason</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{
									pending.map((item, ind) => {

										return <tr key={ind}>
											<td>
												{item.user_code}
											</td>
											<td>
												{item.name}
											</td>
											<td>
												{
													moment(item.start_time, ["HH:mm"]).format("hh:mm A")
												}
											</td>
											<td>
												{moment(item.end_time, ["HH:mm"]).format("hh:mm A")}
											</td>
											<td>{moment(item.regularize_date).format('DD MMM, yyyy')}
											</td>
											<td>{item.user_remarks}</td>
											<td>
												<button onClick={() => {
													handleApproved(item.id, item.user_id, moment(item.regularize_date).format('yyyy-MM-DD'),
														item.start_time,
														item.end_time,
														item.att_id

													)
												}} className="btn_7 mr03">Approve</button>
												<button className="btn_8"  >Reject</button>
											</td>
										</tr>
									})
								}
							</tbody>
							<tfoot>
								<tr><td colSpan="8" >
									<span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
									<ReactPaginate
										ref={pagination}
										pageCount={Math.ceil(totalitem / perPage)}
										pageRangeDisplayed={4}
										marginPagesDisplayed={1}
										onPageChange={setPage}
										containerClassName="pagination"
										activeClassName="active"
										pageLinkClassName="page-link"
										breakLinkClassName="page-link"
										nextLinkClassName="page-link"
										previousLinkClassName="page-link"
										pageClassName="page-item"
										breakClassName="page-item"
										nextClassName="page-item"
										previousClassName="page-item"
										previousLabel={<>&laquo;</>}
										nextLabel={<>&raquo;</>}
									/>
								</td></tr>
							</tfoot>
						</table>
					</div>
					<div id="history" className={`tab-pane ${tab == false ? 'active' : ''}`}>
						<table className="table_style_1">
							<thead>
								<tr>
									<th>Employee Code</th>
									<th>Employee Name</th>
									<th>In Time</th>
									<th>Out Time</th>
									<th>Application Date </th>
									<th style={{ width: "200px !important" }}>Reason</th>
								</tr>
							</thead>
							<tbody>
								{
									approval.map((item, ind) => {
										return <tr key={ind}>
											<td>
												{item.user_code}
											</td>
											<td>
												{item.name}
											</td>
											<td>
												{
													moment(item.start_time, ["HH:mm"]).format("hh:mm A")
												}
											</td>
											<td>
												{moment(item.end_time, ["HH:mm"]).format("hh:mm A")}
											</td>
											<td>{moment(item.att_request_date).format('DD MMM, yyyy')}
											</td>
											<td>{item.user_remarks}</td>
										</tr>
									})
								}

							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div className="row mb30">
				<div className="col-md-12">

				</div>
			</div>
		</div>
	)
}

export default ApprovetimesheetCom
